import { render } from "./YMMIcon.vue?vue&type=template&id=1ab9c695"
import script from "./YMMIcon.vue?vue&type=script&lang=js"
export * from "./YMMIcon.vue?vue&type=script&lang=js"

import "./YMMIcon.vue?vue&type=style&index=0&id=1ab9c695&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__